import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

// Zone de signature au doigt ; renvoie un PNG (Blob) ou null si effacée
export function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const moved = useRef(0);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current;
    const r = c.getBoundingClientRect();
    c.width = r.width * 2; c.height = r.height * 2;
    const ctx = c.getContext("2d");
    ctx.scale(2, 2); ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0B1A4A";
  }, []);
  const pt = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; moved.current = 0; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pt(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pt(e)); ctx.stroke(); moved.current += 1; };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (moved.current < 3 && empty) return;
    setEmpty(false);
    ref.current.toBlob((b) => onChange(b ? new File([b], "signature.png", { type: "image/png" }) : null), "image/png");
  };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };
  return (
    <div className="space-y-1">
      <div className="relative">
        <canvas ref={ref} data-testid={testid} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={up}
          className="w-full h-36 rounded-lg border-2 border-dashed border-slate-300 bg-white touch-none" />
        {empty && <span className="pointer-events-none absolute inset-0 grid place-items-center text-xs text-slate-400">Signez ici avec le doigt</span>}
      </div>
      <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500"><Eraser className="h-3.5 w-3.5" />Effacer</button>
    </div>
  );
}
